namespace $ {
	export let $mol_3d_glsl_both = ''
	export let $mol_3d_glsl_vert = ''
	export let $mol_3d_glsl_frag = ''
}
